import { useTranslation } from '@/src/i18n';
import { Button } from '@/src/presentation/components';
import { Ionicons } from '@expo/vector-icons';
import { KeyboardAvoidingView, Platform, Text, TextInput, View } from 'react-native';
import { createStyles } from './JoinTournamentScreen.styles';

export interface JoinTournamentScreenProps {
  code: string;
  onCodeChange: (code: string) => void;
  onJoin: () => void;
  loading: boolean;
  errorMessage: string;
  colors: {
    background: string;
    surface: string;
    card: string;
    border: string;
    text: string;
    textSecondary: string;
    primary: string;
    primaryText: string;
    error: string;
  };
}

export const JoinTournamentScreen = ({
  code,
  onCodeChange,
  onJoin,
  loading,
  errorMessage,
  colors,
}: JoinTournamentScreenProps) => {
  const styles = createStyles();
  const { t } = useTranslation();

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
      style={[styles.container, { backgroundColor: colors.background }]}
    >
      <View style={styles.content}>
        <Ionicons
          name="key-outline"
          size={48}
          color={colors.primary}
          style={{ alignSelf: 'center', marginBottom: 16 }}
        />
        <Text style={[styles.title, { color: colors.text }]}>
          {t('invitations.joinByCode')}
        </Text>
        <Text style={[styles.subtitle, { color: colors.textSecondary }]}>
          {t('invitations.enterCodeSubtitle')}
        </Text>

        <View style={styles.inputContainer}>
          <Text style={[styles.label, { color: colors.text }]}>{t('invitations.inviteCode')}</Text>
          <TextInput
            style={[
              styles.input,
              {
                borderColor: errorMessage ? colors.error : colors.border,
                backgroundColor: colors.card,
                color: colors.text,
              },
            ]}
            value={code}
            onChangeText={onCodeChange}
            placeholder={t('invitations.enterCode')}
            placeholderTextColor={colors.textSecondary}
            autoCapitalize="characters"
            autoCorrect={false}
            maxLength={8}
          />
          {errorMessage !== '' && (
            <Text style={[styles.errorText, { color: colors.error }]}>{errorMessage}</Text>
          )}
        </View>

        <Button
          title={loading ? t('common.loading') : t('invitations.join')}
          onPress={onJoin}
          variant="primary"
          disabled={loading || code.trim().length === 0}
          colors={colors}
        />
      </View>
    </KeyboardAvoidingView>
  );
};
